import firebase from "firebase";

// Initialize Firebase
const config = {
  apiKey: "AIzaSyD4JGCWRAYXacGSmn2IWyzYexGIFC3TMIg",
    authDomain: "cursoenlinea-neonatologia.firebaseapp.com",
    databaseURL: "https://cursoenlinea-neonatologia.firebaseio.com",
    projectId: "cursoenlinea-neonatologia",
    storageBucket: "cursoenlinea-neonatologia.appspot.com",
    messagingSenderId: "120568927744",
    appId: "1:120568927744:web:a3fe3defcce7fec4e0eae5",
    measurementId: "G-7XM3M74C48"
};

firebase.initializeApp(config);
firebase.auth().languageCode = 'es'
const auth = firebase.auth();
const functions = firebase.functions();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

const database = firebase.firestore();

export {
  database,
  auth,
  functions,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider
};
